export default __webpack_public_path__ + "static/media/image2.1975d5ad.jpeg";